// 관리자 취소 사유 선택 모달 (검차 신청 취소 사유 통지 — BUILD_PLAN §6). v1 EvalAdminPage.js 도 재사용.
// 사유 8종 라디오(코드 뱃지 + needsResubmit 녹색 칩) + 내부 메모 + 발송 안내 고정문 + [닫기]/[취소 확정].
// 목록은 GET /api/eval/orders/cancel-reasons?scope=admin — 실패/미배포(구서버) 시 로컬 폴백(cancelReasons.js, §3 그대로).
// (서버 계약 이탈 — 라우터가 /api/eval/orders 에만 마운트돼 /api/eval/cancel-reasons 가 아니다. 2026-09-23 S 보고 반영.)
// props: open, busy, onClose, onConfirm({reason_code, reason_note})
import React, { useState, useEffect } from 'react';
import { T, S, R, FONT } from '../../theme';
import { API, authFetch } from '../../../utils/api';
import { CANCEL_REASONS_ADMIN } from '../cancelReasons';

var wrap = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,.45)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' };
var box = { width: 'min(520px, 94vw)', maxHeight: '86vh', background: T.card, borderRadius: R.lg, boxShadow: T.shadowMenu, display: 'flex', flexDirection: 'column', overflow: 'clip' };
var headSt = { padding: '14px 16px 10px', borderBottom: '1px solid ' + T.bd };
var titleSt = { fontSize: FONT.title, fontWeight: 800, color: T.navy, letterSpacing: '-.3px' };
var bodySt = { overflowY: 'auto', flex: 1, padding: '12px 16px' };
var radioRow = { display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 8px', borderRadius: R.md, cursor: 'pointer' };
var radioRowOn = Object.assign({}, radioRow, { background: T.accentTint });
// Jin 9/23: 내부 코드(UNIDENTIFIABLE_VEHICLE 등)는 노출하지 않는다 — 제목 = 짧은 라벨, 캡션 = 전문 (앱·웹 바이어 다이얼로그와 동일 구조).
var shortSt = { display: 'block', fontSize: 13.5, fontWeight: 700, color: T.ink };
var labelSt = { fontSize: 13, color: T.body, marginTop: 4, lineHeight: 1.5 };
var resubmitChip = { flexShrink: 0, fontSize: 10.5, fontWeight: 700, color: T.ok, background: T.okTint, border: '1px solid ' + T.okBd, borderRadius: R.pill, padding: '2px 8px' };
// Jin 9/23: 재신청 안내 사유를 위로 모아 보여주고, 의미는 모달 상단 안내문으로 설명한다 (hover 툴팁은 안 보인다는 피드백으로 폐기).
var RESUBMIT_TIP = '"재신청 안내" 뱃지가 붙은 사유로 취소하면 신청자에게 다시 신청 안내와 [다시 신청] 버튼이 함께 표시됩니다.';
var tipSt = { fontSize: FONT.label, color: T.muted, lineHeight: 1.5, marginBottom: 10, padding: '8px 10px', background: T.head, borderRadius: R.sm };
function groupResubmitFirst(list) {
  var a = [], b = [];
  (list || []).forEach(function(r) { (r.needsResubmit ? a : b).push(r); });
  return a.concat(b);
}
// 발송 안내 고정문 — 스크롤되는 bodySt 안에 있으면 사유가 많을 때 스크롤해야만 보였다(V 관찰,
// 2026-09-23). 버튼과 함께 스크롤 밖 고정 푸터로 옮긴다(footWrap) — 항상 보이게.
var footWrap = { flex: 'none', borderTop: '1px solid ' + T.bd };
// Jin 9/23: '신청자 언어로 번역되어 발송' 을 강조 — 파랑 tint 박스 + 굵은 문장.
var noticeSt = { fontSize: 13, fontWeight: 600, color: T.accentPress, background: T.accentTint, borderBottom: '1px solid ' + T.accentBd, padding: '10px 16px', lineHeight: 1.5 };
var footSt = { display: 'flex', gap: 8, padding: '10px 16px', justifyContent: 'flex-end' };

function CancelReasonModal(props) {
  var open = !!props.open;
  var busy = !!props.busy;
  var onClose = props.onClose;
  var stReasons = useState(CANCEL_REASONS_ADMIN); var reasons = stReasons[0], setReasons = stReasons[1];
  var stCode = useState(''); var code = stCode[0], setCode = stCode[1];
  var stNote = useState(''); var note = stNote[0], setNote = stNote[1];

  useEffect(function() {
    if (!open) return undefined;
    setCode(''); setNote(''); setReasons(CANCEL_REASONS_ADMIN);
    authFetch(API + '/eval/orders/cancel-reasons?scope=admin').then(function(r) { return r.json(); }).then(function(d) {
      if (d && d.success && Array.isArray(d.reasons) && d.reasons.length) setReasons(d.reasons);
    }).catch(function() { /* 미배포·네트워크 오류 — 로컬 폴백 유지 */ });
    return undefined;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(function() {
    if (!open) return undefined;
    var onKey = function(e) { if (e.key === 'Escape' && !busy) onClose(); };
    window.addEventListener('keydown', onKey);
    return function() { window.removeEventListener('keydown', onKey); };
  }, [open, busy, onClose]);

  if (!open) return null;

  return (<div style={wrap} onClick={function() { if (!busy) onClose(); }}>
    <div role="dialog" aria-label="취소 사유 선택" style={box} onClick={function(e) { e.stopPropagation(); }}>
      <div style={headSt}><span style={titleSt}>취소 사유 선택</span></div>
      <div style={bodySt}>
        <div style={tipSt} className="v2-eval-cancel-tip">{RESUBMIT_TIP}</div>
        {groupResubmitFirst(reasons).map(function(r) {
          var on = code === r.code;
          return (<label key={r.code} style={on ? radioRowOn : radioRow}>
            <input type="radio" name="cancel-reason-code" value={r.code} checked={on}
              onChange={function() { setCode(r.code); }}/>
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={shortSt}>{(r.short && r.short.ko) || (r.label && r.label.ko)}</span>
              <div style={labelSt}>{r.label && r.label.ko}</div>
            </span>
            {r.needsResubmit ? <span style={resubmitChip}>재신청 안내</span> : null}
          </label>);
        })}
        <div style={{ marginTop: 12 }}>
          <label style={S.label} htmlFor="cancel-reason-note">내부 메모 (선택 · 신청자에게 노출되지 않습니다)</label>
          <textarea id="cancel-reason-note" style={S.textarea} value={note} maxLength={500}
            onChange={function(e) { setNote(e.target.value); }}/>
        </div>
      </div>
      <div style={footWrap}>
        <div style={noticeSt} className="v2-eval-cancel-notice">취소 사유는 신청자의 언어로 번역되어 푸시 알림으로 전달됩니다.</div>
        <div style={footSt}>
          <button type="button" style={S.btn} disabled={busy} onClick={onClose}>닫기</button>
          <button type="button" style={S.btnDanger} disabled={!code || busy}
            onClick={function() { props.onConfirm({ reason_code: code, reason_note: note }); }}>취소 확정</button>
        </div>
      </div>
    </div>
  </div>);
}

export default CancelReasonModal;
